import { Link } from "react-router-dom";
//import { useLocation } from "react-router-dom";

const WithdrawalSuccess = () => {


   /* const{state} = useLocation();

    const amount = state.amount || 0
    const campaignTitle = state.campaign || 'Sample campaign title';
    const bal = state.availabeBalance || 0;
    const receiver = state.receiver;
    //const paymentethod = state.paymentethod;
    const currency = state.currency;*/
    return (
      <div style={styles.container}>
        <h2>Withdrawal Accepted For Processing</h2>
        <p>Withdrawal request has been accepted and details of the transaction will be messaged to you shortly on your mobile phone or email associated with your account.</p>
        <p>Thank you for choosing <strong>FundReach</strong> your best fundraising solution</p>
      {/*  <p>
          You have successfully withdrawn{' '}
          <strong>
            {currency} {amount.toFixed(2)}
          </strong>{' '}
          from the campaign: <strong>{campaignTitle}</strong> to M-PESA number <strong>{receiver}</strong>.
        </p>
        <p>
          Your new available balance is{' '}
          <strong>
            {currency} {bal.toFixed(2)}
          </strong>.
        </p>*/}
        <br/>
        <Link to="/dashboard">Back Dashboard</Link>
      </div>
    );
  };
  
  // Define styles for the component (optional, for better presentation)
  const styles = {
    container: {
      padding: '20px',
      border: '1px solid #ccc',
      borderRadius: '8px',
      backgroundColor: '#f9f9f9',
      maxWidth: '400px',
      margin: '20px auto',
      textAlign: 'center' as 'center', // Type assertion for TypeScript
    },
  };
  
  export default WithdrawalSuccess;
  